if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          caption: this.querySelector('[data-thumbnail-caption]'),
          captionWrapper: this.querySelector('[data-thumbnail-caption-wrapper]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

	        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', () => {
            // Keep thumbnail taps in-page so mobile doesn't flash back to Hero
            // during a full URL navigation before variant sync finishes.
            this.setActiveMedia(mediaToSwitch.dataset.target, false);
            this.dispatchThumbnailVariantSync(mediaToSwitch, 'thumbnail');
          });
        });

        this.updateActiveCaptionFromThumbnail(
          this.elements.thumbnails.querySelector('button[aria-current]')?.closest('[data-target]')
        );

        this.preloadGalleryImages();
        this.initMobileSwipeNavigation();

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      preloadGalleryImages() {
        const images = Array.from(this.elements.viewer?.querySelectorAll('.product__media img') || []);
        if (!images.length) return;

        const preload = () => {
          images.forEach((image) => {
            if (!image.currentSrc && !image.src && !image.srcset) return;
            if (image.complete) return;

            const preloader = new Image();
            preloader.decoding = 'async';
            if (image.sizes) preloader.sizes = image.sizes;
            if (image.srcset) preloader.srcset = image.srcset;
            preloader.src = image.currentSrc || image.src;
          });
        };

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(preload, { timeout: 1200 });
          return;
        }

        window.setTimeout(preload, 400);
      }

      initMobileSwipeNavigation() {
        const slider = this.elements.viewer?.slider;
        if (!slider) return;

        // Use the native horizontal slider gesture on mobile, then sync the
        // selected variant after the slider itself settles on a new slide.
        slider.style.scrollBehavior = 'smooth';
      }

      onSlideChanged(event) {
        const currentElement = event.detail?.currentElement;
        if (!currentElement || !currentElement.dataset?.mediaId) return;

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${currentElement.dataset.mediaId}"]`
        );

        this.setActiveThumbnail(thumbnail);

        if (
          !this.mql.matches &&
          thumbnail?.dataset?.variantId &&
          thumbnail?.dataset?.galleryRole !== 'artwork-hero'
        ) {
          this.dispatchThumbnailVariantSync(thumbnail, 'swipe');
        }
      }

	      setActiveMedia(mediaId, prepend) {
  const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
  if (!activeMedia) {
    return;
  }
  this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
    element.classList.remove('is-active');
  });
  activeMedia?.classList?.add('is-active');

  if (prepend) {
    activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

    if (this.elements.thumbnails) {
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
    }

    if (this.elements.viewer.slider) this.elements.viewer.resetPages();
  }

  this.preventStickyHeader();
  window.setTimeout(() => {
    if (!this.mql.matches || this.elements.thumbnails) {
      activeMedia.parentElement.scrollTo({
        left: activeMedia.offsetLeft,
        behavior: this.mql.matches ? 'auto' : 'smooth',
      });
    }
    const activeMediaRect = activeMedia.getBoundingClientRect();
    // Don't scroll if the image is already in view
    if (activeMediaRect.top > -0.5) return;
    const top = activeMediaRect.top + window.scrollY;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });
  this.playActiveMedia(activeMedia);

  if (!this.elements.thumbnails) return;
  const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
  if (!activeThumbnail) return;
  this.setActiveThumbnail(activeThumbnail);
  this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
}

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        this.updateActiveCaptionFromThumbnail(thumbnail);

        if (!this.mql.matches && thumbnail.dataset.galleryRole === 'artwork-hero') return;

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

	      updateActiveCaptionFromThumbnail(thumbnail) {
	        if (!this.elements.caption || !this.elements.captionWrapper) return;

          const galleryRole = thumbnail?.dataset?.galleryRole?.trim() || '';
	        const label = (thumbnail?.dataset?.thumbnailLabel?.trim() || '')
            .replace('12X12"', '12x12"')
            .replace('10X10"', '10x10"');
	        this.elements.caption.replaceChildren();

          if (!label || galleryRole === 'artwork-hero' || galleryRole === 'in-room' || label === 'In Room') {
            this.elements.captionWrapper.hidden = true;
            return;
          }

	        this.elements.caption.textContent = label;
	        this.elements.captionWrapper.hidden = !label;
	      }

      dispatchThumbnailVariantSync(thumbnail, source = 'thumbnail') {
        const detail = {
          label: thumbnail?.dataset?.thumbnailLabel?.trim() || '',
          variantId: thumbnail?.dataset?.variantId || '',
          galleryRole: thumbnail?.dataset?.galleryRole || '',
          source,
        };

        const productInfo = this.closest('product-info');
        if (productInfo) {
          // Thumbnail clicks already activated the requested media. Sync only
          // product state here so the variant flow cannot jump back to Hero.
          this.syncVariantPriceFromThumbnail(detail, productInfo);
          return;
        }

        this.dispatchEvent(
          new CustomEvent('thumbnailVariantSync', {
            detail,
            bubbles: true,
            composed: true,
          })
        );
        this.syncVariantPriceFromThumbnail(detail, productInfo);
      }

      syncVariantPriceFromThumbnail(detail, productInfo = this.closest('product-info')) {
        if (detail.galleryRole === 'artwork-hero' || detail.galleryRole === 'in-room' || !productInfo) return;

        const variant = this.findVariantForThumbnail(detail, productInfo);
        if (!variant?.id || variant.price == null) return;

        const applyPriceState = () => this.applyVariantPriceState(productInfo, variant);
        applyPriceState();
        window.setTimeout(applyPriceState, 300);
      }

      findVariantForThumbnail({ variantId, label }, productInfo = this.closest('product-info')) {
        const variants = this.getProductVariants(productInfo);
        if (!Array.isArray(variants)) return null;

        const byId = variants.find((variant) => String(variant.id) === String(variantId));
        if (byId) return this.normalizeMetaVariant(byId);

        const labelParts = String(label || '').trim().match(/^(\d+)\s*[x×]\s*(\d+")\s+(.+)$/i);
        if (!labelParts) return null;

        const expectedOptions = [`${labelParts[1]}X${labelParts[2]}`, labelParts[3]];
        const matched = variants.find((variant) => {
          const options = this.getMetaVariantOptions(variant);
          return expectedOptions.every(
            (option, index) => this.normalizeVariantOption(option) === this.normalizeVariantOption(options[index])
          );
        });

        return matched ? this.normalizeMetaVariant(matched) : null;
      }

      getProductVariants(productInfo = this.closest('product-info')) {
        const variantsJson = productInfo?.querySelector('variant-selects [data-product-variants]')?.textContent;
        if (variantsJson) {
          try {
            return JSON.parse(variantsJson);
          } catch (error) {
            console.error('Unable to parse embedded product variants for thumbnail sync.', error);
          }
        }

        return window.meta?.product?.variants;
      }

      normalizeMetaVariant(variant) {
        return {
          ...variant,
          available: variant.available !== false,
          compare_at_price: variant.compare_at_price ?? null,
          options: this.getMetaVariantOptions(variant),
          title: variant.public_title || this.getMetaVariantOptions(variant).join(' / '),
        };
      }

      getMetaVariantOptions(variant) {
        return String(variant.public_title || variant.name || '')
          .replace(/^.*? - /, '')
          .split(' / ')
          .map((option) => option.trim())
          .filter(Boolean);
      }

      applyVariantPriceState(productInfo, variant) {
        productInfo.updateURL?.(productInfo.dataset.url, variant.id);
        productInfo.updateVariantInputs?.(variant.id);
        this.updateVariantSelects(productInfo, variant);

        const selectedVariantScript = productInfo.querySelector('variant-selects [data-selected-variant]');
        if (selectedVariantScript) selectedVariantScript.textContent = JSON.stringify(variant);

        const priceContainer = productInfo.querySelector(`#price-${productInfo.dataset.section}`);
        if (priceContainer) {
          const formattedPrice = this.formatMoneyWithCurrency(variant.price);
          const hasCompareAtPrice = Number(variant.compare_at_price) > Number(variant.price);
          const formattedCompareAtPrice = hasCompareAtPrice ? this.formatMoneyWithCurrency(variant.compare_at_price) : '';

          priceContainer
            .querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale')
            .forEach((node) => {
              node.textContent = formattedPrice;
            });
          priceContainer
            .querySelectorAll('.price__sale .price-item--regular, .variant-item__old-price')
            .forEach((node) => {
              node.textContent = formattedCompareAtPrice;
            });
          priceContainer.querySelector('.price')?.classList.toggle('price--on-sale', hasCompareAtPrice);
          priceContainer.querySelector('.price')?.classList.toggle('price--sold-out', variant.available === false);
        }

        productInfo.querySelector('shopify-payment-terms')?.setAttribute('variant-id', variant.id);
      }

      updateVariantSelects(productInfo, variant) {
        const selects = Array.from(productInfo.querySelectorAll('variant-selects select'));
        variant.options?.forEach((optionValue, index) => {
          const select = selects[index];
          if (!select) return;

          const matchingOption = Array.from(select.options).find(
            (option) => this.normalizeVariantOption(option.value) === this.normalizeVariantOption(optionValue)
          );
          if (!matchingOption) return;

          select.value = matchingOption.value;
          Array.from(select.options).forEach((option) => {
            const isSelected = option === matchingOption;
            option.selected = isSelected;
            if (isSelected) {
              option.setAttribute('selected', 'selected');
            } else {
              option.removeAttribute('selected');
            }
          });
        });
      }

      normalizeVariantOption(value) {
        return String(value || '')
          .trim()
          .replace(/\s+/g, ' ')
          .replace(/(\d+)\s*[x×]\s*(\d+")/i, '$1X$2')
          .toLowerCase();
      }

      formatMoneyWithCurrency(valueInCents) {
        const amount = Number(valueInCents || 0) / 100;
        return `${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount)} USD`;
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
